import React, { useEffect } from "react";

import { useAppType, useInView, useTranslation } from "utils";

import { ArticleCard, Button, Col, NewsCard, Row } from "components";

export const ArticleResults = ({ articles, loadMore, loading, loadingMore, searching, noMore, user }) => {
  const { t } = useTranslation(["search"]);
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: false,
    trackVisibility: true,
    delay: 100,
  });
  const appType = useAppType();

  useEffect(() => {
    if (inView && user) {
      loadMore();
    }
  }, [inView, loadMore, user]);

  return (
    <>
      {appType.desktop ? (
        <>
          <Row>
            <Col sm={24} md={8}>
              {articles.map((article, i) => {
                if (i % 3 === 0 && (article.type === "article" || !article)) {
                  return (
                    <Row key={i}>
                      <Col>
                        <ArticleCard link={article.link} />
                      </Col>
                    </Row>
                  );
                }
                if (i % 3 === 0 && article.type === "news") {
                  return (
                    <Row key={i}>
                      <Col>
                        <NewsCard className="margin-bottom-50" link={article.link} />
                      </Col>
                    </Row>
                  );
                }
                return null;
              })}
            </Col>
            <Col sm={24} md={8}>
              {articles.map((article, i) => {
                if (i % 3 !== 0 && i % 2 !== 0 && (article.type === "article" || !article)) {
                  return (
                    <Row key={i}>
                      <Col>
                        <ArticleCard link={article.link} />
                      </Col>
                    </Row>
                  );
                }
                if (i % 3 !== 0 && i % 2 !== 0 && article.type === "news") {
                  return (
                    <Row key={article.id}>
                      <Col>
                        <NewsCard className="margin-bottom-50" link={article.link} />
                      </Col>
                    </Row>
                  );
                }
                return null;
              })}
            </Col>
            <Col sm={24} md={8}>
              {articles.map((article, i) => {
                if (i % 2 === 0 && i % 3 !== 0 && (article.type === "article" || !article)) {
                  return (
                    <Row key={i}>
                      <Col>
                        <ArticleCard link={article.link} />
                      </Col>
                    </Row>
                  );
                }
                if (i % 2 === 0 && i % 3 !== 0 && article.type === "news") {
                  return (
                    <Row key={i}>
                      <Col>
                        <NewsCard className="margin-bottom-50" link={article.link} />
                      </Col>
                    </Row>
                  );
                }
                return null;
              })}
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          {/* prelint-ignore-col */}
          {articles.map((article, i) => {
            if (article.type === "news") {
              return (
                <Col sm={24} md={12} key={i}>
                  <NewsCard link={article.link} />
                </Col>
              );
            }
            return (
              <Col sm={24} md={12} key={i}>
                <ArticleCard link={article.link} />
              </Col>
            );
          })}
        </Row>
      )}
      {!noMore && !loadingMore && !searching && !loading && (
        <>
          {user ? (
            <div ref={ref} />
          ) : (
            <Row>
              <Col className="center">
                <Button disabled={loading} onClick={() => loadMore()}>
                  {t("buttons.more")}
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}
    </>
  );
};
